import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { homeFor } from '../auth/gate';
import { HushedFrame } from '../screens/auth/HushedFrame';
import { SignUpPage } from '../screens/auth/SignUpPage';
import { chosenPlanOf, chosenPlanSearch } from '../screens/auth/chosen-plan';

const searchSchema = z.object({
  /** `company` when the identity already exists (signed in with no company yet). */
  step: z.enum(['identity', 'company']).optional(),
  /** The address to start from (Paige Mobile's "Start your own Paige"). */
  email: z.string().email().max(254).optional(),
  /** The company whose invitation's link this is: the account made here joins it (anything else is dropped). */
  invite: z.string().uuid().optional().catch(undefined),
  /** The paid plan and interval picked on the pricing page; its checkout follows the company. */
  ...chosenPlanSearch,
});

/** Create an account, then name the company; Paige makes it on Free, then opens the chosen plan's checkout. */
export const Route = createFileRoute('/sign-up')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context }) => {
    const principal = await context.auth.ensureOrNone();
    if (principal && principal.tenants.length > 0) throw redirect(homeFor(principal));
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { step, email, invite, plan, interval } = Route.useSearch();
  return (
    <SignUpPage
      initialStep={step ?? 'identity'}
      email={email}
      invitation={invite}
      plan={chosenPlanOf(plan, interval)}
      Frame={HushedFrame}
    />
  );
}
